import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector, useDispatch } from "react-redux";
import { storageActions } from "../../../redux/actions/guides";
import { SimpleModal, MyInput, DialogModal } from "../../../components";
import * as Yup from "yup";
import DeleteIcon from '@material-ui/icons/Delete';
import { Button } from "@material-ui/core";
import { useStateIfMounted } from "use-state-if-mounted";

const defaultValues = {
  nameStorage: "",
  description: "",
  address: "",
};

const validationSchema = Yup.object().shape({
  nameStorage: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").required("Обязательное для заполнения поле"),
  description: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
  address: Yup.string().max(255, "Превышено максимальное кол-во символов(255)").nullable(),
});

export const ModalStorage = ({ modalShow, onClose, id, refresh = () => {} }) => {
  const dispatch = useDispatch();
  const { item, loadingItem, fetchedItem, deleted, error } = useSelector((state) => state.guides.storages);

  const [deleteDialog, setDeleteDialog] = useStateIfMounted(false);
  const [isAddMode, setIsAddMode] = useState(true); // По умолчанию режим добавления

  const {
    control,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = (data) => {
    return isAddMode ? dispatch(storageActions.create(data)) : dispatch(storageActions.update(item.id, data));
  };

  // для определения режима при открытии модального окна
  useEffect(() => {
    if (!modalShow) return;

    // Если передан id - режим редактирования, иначе - добавления
    if (id) {
      setIsAddMode(false);
      dispatch(storageActions.getById(id));
    } else {
      setIsAddMode(true);
      reset(defaultValues); // Сброс формы для нового склада
    }

    return () => dispatch({ type: "RESET_ITEM_STORAGES" });
  }, [modalShow, id, dispatch, reset]);

  // для заполнения формы при получении данных
  useEffect(() => {
    if (!fetchedItem || isAddMode) return;

    Object.keys(defaultValues).forEach((field) => setValue(field, item[field]));
  }, [item, fetchedItem, isAddMode, setValue]);

  // для переключения в режим редактирования после успешного создания
  useEffect(() => {
    // Если был режим добавления и данные успешно получены после создания
    if (isAddMode && fetchedItem && item?.id) {
      setIsAddMode(false);
    }
  }, [fetchedItem, item, isAddMode]);

  // для обработки успешного создания/обновления
  useEffect(() => {
    if (fetchedItem && !loadingItem) {
      // Если в режиме добавления и создание успешно - переключаемся в редактирование
      if (isAddMode && item?.id) {
        // Не закрываем модалку, остаемся в режиме редактирования
      } else if (!isAddMode) {
        // В режиме редактирования 
      }
    }
  }, [fetchedItem, loadingItem, item, isAddMode]);

  const handleDeleteClick = useCallback((id) => {
    dispatch(storageActions.delete(id));
    setDeleteDialog(false);
  }, [dispatch, setDeleteDialog]);

  // удаление успешное
  useEffect(() => {
    if (deleted && modalShow) {
      setDeleteDialog(false);
      closeModalFunc();
      onClose();
      refresh();
      console.log('Склад успешно удален');
    }
  }, [deleted]);

  const closeModalFunc = () => {
    clearErrors();
    reset(defaultValues);
    setIsAddMode(true); // Сбрасываем в режим добавления при закрытии
  };

  return (
    <div>
      <SimpleModal
        modalTitle={isAddMode ? "Новый склад" : "Редактирование"}
        winPermissionName="Общие"
        modalShow={modalShow}
        modalSize="sm"
        fullScreen={false}
        loading={loadingItem}
        isAddMode={isAddMode}
        status={!isAddMode}
        operations={item}
        onSubmit={handleSubmit(onSubmit)}
        onClose={() => {
          onClose();
          closeModalFunc();
        }}
      >
        <form noValidate>
          <MyInput 
            name="nameStorage" 
            control={control} 
            label="Наименование склада" 
            required 
            errors={errors?.nameStorage} 
          />
          <MyInput 
            name="address" 
            control={control} 
            label="Адрес" 
            multiline 
            rows={3} 
            errors={errors?.address}
          />
          <MyInput 
            name="description" 
            control={control} 
            label="Комментарий" 
            multiline 
            rows={3} 
            errors={errors?.description}
          />
          {!isAddMode && (
            <div>
              <Button
                disabled={item?.id === null || item?.id === undefined}
                aria-describedby={id}
                size="small"
                color="primary"
                onClick={() => setDeleteDialog(true)}
                startIcon={<DeleteIcon />}
              >
                Удалить
              </Button>
            </div>
          )}
        </form>
      </SimpleModal>
      <DialogModal
        open={deleteDialog}
        onConfirmDialogClose={() => setDeleteDialog(false)}
        onYesClick={() => handleDeleteClick(item?.id)}
        text={`Вы действительно хотите удалить склад - ${item?.nameStorage}? Это действие невозможно отменить.`}
      />
    </div>
  );
};